<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>

	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Menu'" [includeDescription]="true"
			[otherNames]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<form class="example-container k-body">
			<div class="page-live-header">
				<select class="page-live-example-select" (change)="changeCurrLive($event)" title="Change Example">
					<option value="button-trigger">Button trigger</option>
					<option value="icon-button-trigger">
						Icon button trigger
					</option>
					<option value="separator">With separator</option>
				</select>
				<app-theme-switcher></app-theme-switcher>
			</div>
			<div class="page-live-example-content">
				<div class="flex-x h-fill button-with-menu-wrapper">
					<kendo-menu #menu1 [openOnClick]="{ toggle: 'click' }" (close)="onClose($event)"
						[class.page-live-show]="currLive === 'button-trigger'">
						<ng-template kendoMenuItemLinkTemplate let-item="item" let-index="index">
							<kendo-button themeColor="primary" fillMode="flat" [kendoMenuItemLink]="index"
								[svgIcon]="item.svgIcon">
								{{ item.text }}
								<span *ngIf="item.items && item.items.length" [kendoMenuExpandArrow]="index"></span>
							</kendo-button>
						</ng-template>
						<kendo-menu-item [text]="buttonTriggerMenu.text" [svgIcon]="buttonTriggerMenu.icon">
							<kendo-menu-item *ngFor="let subitem of buttonTriggerMenu.items" [text]="subitem.text"
								[svgIcon]="subitem.icon">
							</kendo-menu-item>
						</kendo-menu-item>
					</kendo-menu>

					<kendo-menu #menu2 [openOnClick]="{ toggle: 'click' }" (close)="onClose($event)"
						[class.page-live-show]="
							currLive === 'icon-button-trigger'
						">
						<ng-template kendoMenuItemLinkTemplate let-item="item" let-index="index">
							<kendo-button themeColor="primary" fillMode="flat" [kendoMenuItemLink]="index"
								[svgIcon]="item.svgIcon">
								{{ item.text }}
							</kendo-button>
						</ng-template>
						<kendo-menu-item [text]="iconButtonTriggerMenu.text" [svgIcon]="iconButtonTriggerMenu.icon">
							<kendo-menu-item *ngFor="
									let subitem of iconButtonTriggerMenu.items
								" [text]="subitem.text" [svgIcon]="subitem.icon" [separator]="subitem.text === 'separator'"
								[disabled]="subitem.disabled">
							</kendo-menu-item>
						</kendo-menu-item>
					</kendo-menu>

					<kendo-menu #menu3 [openOnClick]="{ toggle: 'click' }" (close)="onClose($event)"
						[class.page-live-show]="currLive === 'separator'">
						<ng-template kendoMenuItemLinkTemplate let-item="item" let-index="index">
							<kendo-button themeColor="primary" fillMode="flat" [kendoMenuItemLink]="index"
								[svgIcon]="item.svgIcon">
								{{ item.text }}
								<span *ngIf="item.items && item.items.length" [kendoMenuExpandArrow]="index"></span>
							</kendo-button>
						</ng-template>
						<kendo-menu-item [text]="menuWithSeparator.text" [svgIcon]="menuWithSeparator.icon">
							<kendo-menu-item *ngFor="let subitem of menuWithSeparator.items" [text]="subitem.text"
								[svgIcon]="subitem.icon" [separator]="subitem.text === 'separator'">
							</kendo-menu-item>
						</kendo-menu-item>
					</kendo-menu>
				</div>
			</div>
		</form>
	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>

		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>

			<pre prism class="dark" [hidden]="currLive !== 'button-trigger'">
				{{ buttonTriggerMenuHTML }}
			</pre>

			<pre prism class="dark" [hidden]="currLive !== 'icon-button-trigger'">
				{{ iconButtonTriggerMenuHTML }}
			</pre>

			<pre prism class="dark" [hidden]="currLive !== 'separator'">
				{{ menuWithSeparatorHTML }}
			</pre>
		</section>
		<section class="page-sub-section" id="dev-api">
			<h3 id="subSectionTitleDevApi" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-api')">
				API <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/menus/api/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo Menu API</a>
				</li>
				<li class="page-section-list-item">
					Refer to the
					<a href="components/menu#behaviors">behaviors section</a>
					to see supported component features.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>

					<span class="page-style-list-title">Menu item</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Trigger - text button with icon</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultTextButton" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Trigger - icon button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultIconButton" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>

					<span class="page-style-list-title">Menu item</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Trigger - text button with icon</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkTextButton" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Trigger - icon button</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkIconButton" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<span class="page-style-list-title">Menu item</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypography" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Trigger - text button with icon</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypographyTrigger" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>
	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>

		<section class="page-sub-section" id="behaviors-focus">
			<h3 id="subSectionTitleStyles" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-focus')">
				Focus <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					When the menu's control is focused on, the menu opens to
					display the list of items. The menu closes when the control
					loses focus. Both the opening and closing is animated and
					lasts 250ms, per our <a href="guidelines/motion">motion guidelines</a>. A focus state
					replaces the browser default focus state for the input box
					of a menu.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-disabled">
			<h3 id="subSectionTitleBehaviorsDisabled" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-disabled')">
				Disabled <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Entire menu</span>
					When disabled, the menu is shown at 50% opacity. It cannot
					be clicked, focused, or interacted with in any way.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Menu items</span>
					If a menu item could be used but is currently not an option,
					keep it in the menu list but have it disabled. Keeping it in
					the list keeps the user aware of what options exist—even if
					some can't be performed right now. Disabled items also have
					50% opacity and have no interactions or hover state.
				</li>
			</ul>
		</section>

		<section class="page-sub-section" id="behaviors-scrollbars">
			<h3 id="subSectionTitleBehaviorsScrollbars" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-scrollbars')">
				Scrollbars <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					The menu should be tall enough to fit up to 8 items at first
					glance. After 8 items, the menu becomes vertically
					scrollable. If the menu has less than 8 items, it should
					only be as tall as the options in it—no scrollbar needed.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="variations">
		<h2 id="sectionTitleVariations" class="page-section-title page-section-title-empty"
			title="Copy Link to Clipboard" (click)="copyToClipboard('variations')">
			Variations <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-section-content">
			There are no variations for this component.
		</section>
	</section>
	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-general">
			<h3 id="subSectionTitleUsageGeneral" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-general')">
				General <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-do-list-title">Do:</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							Use menus to allow users to perform actions.
						</li>
					</ul>
				</li>
			</ul>
			<ul class="page-section-list">
				<li class="page-section-list-item" style="margin-top: 5px">
					<span class="page-section-do-list-title">Don't:</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							Use menus to allow users to select options — use a
							drop-down instead.
						</li>
					</ul>
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Order</span>
				</li>
				<li class="page-section-list-item">
					The order of menu items isn't arbitrary—it's driven by data,
					logic, and research. Generally, the most common actions
					appear at the top of a menu, or the “ideal” options that a
					user should select. Ideal meaning the options we want users
					to select based on their goals and the goals of the
					business. In most cases, destructive actions like delete are
					placed at the bottom of the list.
				</li>
				<li class="page-section-list-item">
					Other ways to structure menus are alphabetically (A-Z) and
					chronologically (newest to oldest).
				</li>

				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Label</span>
					Labels should be short, 3 words or fewer. Labels should use
					title case. Labels should briefly and accurately summarize
					the menu items.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Items</span>
					If the menu items are actions, they should start with verb
					and then a noun. Be specific.
				</li>
				<li>
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="doThisIcon"></kendo-svg-icon>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Duplicate Policy
									</li>
								</ul>
							</div>
						</li>
						<li class="page-section-comparison-list-item comparison-do-not">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="notThisIcon"></kendo-svg-icon>
								Not this
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Duplicate
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
				<li class="page-section-list-item">
					You can use ellipses when the action doesn't have an
					immediate effect. Ellipses show users that they need to do
					something else to complete the action, like choose a printer
					after selecting <b>Print.</b> Ellipses aren't needed if the
					item just takes a user to another screen.
				</li>
				<li>
					<ul class="page-section-comparison-list">
						<li class="page-section-comparison-list-item comparison-do">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="doThisIcon"></kendo-svg-icon>
								Try This
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										Print...
									</li>
								</ul>
							</div>
						</li>
						<li class="page-section-comparison-list-item comparison-do-not">
							<div class="page-section-comparison-header">
								<kendo-svg-icon [icon]="notThisIcon"></kendo-svg-icon>
								Not this
							</div>
							<div class="page-section-comparison-body">
								<ul class="comparison-body-text-list">
									<li class="comparison-body-text-list-item">
										View Advanced Details
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title" style="margin-top: 16px">Icons</span>
					Icons can be used as both the menu's trigger control and to
					the left of the list items themselves. Refer to the
					<a href="guidelines/icons">Icon guidelines</a> to make sure
					you're using the right icons for your selections or labels.
					Using icons consistently builds recognition and improves
					their effectiveness.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Separators and section titles</span>
					Separators can help build groupings and relationships in
					sections of a menu. Separators can have titles, like
					Favorites or Frequently Used.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-placement">
			<h3 id="subSectionTitleUsagePlacement" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-placement')">
				Placement <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Menus are typically aligned with the left of the trigger.
					Their placement depends on where the trigger is. For
					example, if the list would be cut off by the bottom of the
					browser window, it should open upward. Menus also shouldn't
					“fall off” either side of the screen or hide important
					content when opened.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-list-dimensions">
			<h3 id="subSectionTitleUsageListDimensions" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-list-dimensions')">
				Dimensions <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Menus lists start at a 240px wide and can go up to 400px
					wide. This helps provide enough room for list labels and
					icons.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/button">Button component</a>
			</li>
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="components/data-grid">Data grid component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/icon">Icon component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/motion">Motion guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>
	</section>
	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Menu Component'
						)
					">
				<span class="page-history-list-item-title">{{
					changelogService.formatDate(subItem.changeDate)
					}}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>